import { FormStatusEnum } from "@/components/molecules/FormWrapper/FormWrapper.types";
import { useEffect, useState } from "react";
import { useTitle } from "@/core/context/TitleContext";
import { Loading } from "@/components/atoms/Loading/Loading";
import { FormHeader } from "@/components/molecules/FormHeader/FormHeader";
import { DashboardGraphicsFilters } from "@/modules/dashboard/presentation/DashboardGraphicsFilters";
import { useDashboardGraphicsData } from "@/modules/dashboard/application/hooks/useDashboardGraphicsData";
import { GraphicsFilterEnum, RawData } from "@/modules/dashboard/domain/entities/DashboardEntity";
import { DataTable } from "@/components/molecules/DataTable";
import { dashboardGraphicsColumns } from "@/modules/dashboard/infrastructure/DashboardConstants";
import { DashboardGraphicsDonutCharts } from "@/modules/dashboard/presentation/DashboardGraphicsDonutCharts";

export const DashboardGraphicsPage = () => {
  const [formStatus, setFormStatus] = useState<FormStatusEnum>(FormStatusEnum.List);
  const [dashboardGraphicsSelected, setDashboardGraphicsSelected] = useState<RawData[]>([]);
  const [portfolioSelected, setPortfolioSelected] = useState<string>("");
  const [fieldsSelected, setFieldsSelected] = useState<GraphicsFilterEnum[]>([]);

  const { setTitle } = useTitle();
  const {
    dashboardGraphics,
    portfolioOptions,
    graphicsOptions,
    isLoading,
    dashboardGraphicsRefetch,
  } = useDashboardGraphicsData();

  useEffect(() => {
    setTitle("Dashboard");
  }, [setTitle]);

  useEffect(() => {
    if (!portfolioSelected) {
      setDashboardGraphicsSelected([]);
    } else {
      const sel = portfolioOptions.find((o) => o.value === portfolioSelected)?.label;
      setDashboardGraphicsSelected(
        dashboardGraphics.filter((dg) => dg.portfolio === sel)
      );
    }
  }, [portfolioSelected, dashboardGraphics, portfolioOptions]);

  if (isLoading) return <Loading />;

  return (
    <>
      <FormHeader
        title="Visor de portafolio"
        changeFormStatus={setFormStatus}
        formStatus={formStatus}
        refetch={dashboardGraphicsRefetch}
      />

      <div className="space-y-6">
        <DashboardGraphicsFilters
          portfolioOptions={portfolioOptions}
          portfolio={portfolioSelected}
          setPortfolio={setPortfolioSelected}
          graphicsOptions={graphicsOptions}
          graphics={fieldsSelected}
          setGraphics={setFieldsSelected}
        />

        <DashboardGraphicsDonutCharts
          data={dashboardGraphicsSelected}
          fieldsSelected={fieldsSelected}
          graphicsOptions={graphicsOptions}
        />

        <DataTable
          data={dashboardGraphicsSelected}
          columns={dashboardGraphicsColumns}
          tableHeadClass="bg-primary-500 text-white"
          pageSize={10}
          changeFormStatus={setFormStatus}
        />
      </div>
    </>
  );
};
